import { KYMW0C00Model } from '../kymw0c00.model';
import { UpdateImageInfoModel } from '../vo/update-image-info.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像作成指示画面　画像作成指示を更新するサービス
 *
 * @export UpdateImageInfoService
 * @class UpdateImageInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateImageInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof UpdateImageInfoService
   */
  private model: KYMW0C00Model;

  /**
   * 画像情報更新用VO
   *
   * @private
   * @type {UpdateImageInfoModel}
   * @memberof UpdateImageInfoService
   */
  private vo: UpdateImageInfoModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof UpdateImageInfoService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        ImageInfo: {
          parameter: {
            ImageGroupNO: this.vo.ImageGroupNO,
            StartOrderCode: this.vo.StartOrderCode,
            EndOrderCode: this.vo.EndOrderCode,
            EFriendsProduct: PlessViewUtilsSub.booleanTOString(this.vo.EFriendsProduct),
            ImageBelongID: this.vo.ImageBelongID,
            PCode: this.vo.PCode,
            PhotoSchedule: this.vo.PhotoSchedule,
            PhotoStudioID: this.vo.PhotoStudioID,
            SampleOrderingCode: this.vo.SampleOrderingCode,
            BillingCode: this.vo.BillingCode,
            BillingTargetDiv: PlessViewUtilsSub.booleanTOString(this.vo.BillingTargetDiv),
            Memo: this.vo.Memo,
            ImageKind: this.vo.ImageKind
          }
        },
        ImageInfoInsertList: {
          combination: this.vo.ImageInfoInsertList.map(insertVO => {
            return {
              condition: {
                ImageType: insertVO.ImageType,
                ProcessInstruct: insertVO.ProcessInstruct,
                CookingExPublish: insertVO.CookingExPublish,
                CookingDiv: insertVO.CookingDiv,
                CookingName: insertVO.CookingName,
                MaterialName: insertVO.MaterialName,
                EventID: insertVO.EventID,
                PhotoContentsDiv: insertVO.PhotoContentsDiv,
                Remarks: insertVO.Remarks,
                KeyWord: insertVO.KeyWord,
                PhotoInstructContents: insertVO.PhotoInstructContents,
                TextCaption: insertVO.TextCaption,
                MultipleCode: insertVO.MultipleCode,
                SampleNum: insertVO.SampleNum,
                PromotionFlg: insertVO.PromotionFlg ? '1' : '0',
                Shooting: insertVO.Shooting,
                ShootingPackageText: insertVO.ShootingPackageText,
                ShootingAngle: insertVO.ShootingAngle,
                Alignment: insertVO.Alignment,
                AlignmentHorizontal: insertVO.AlignmentHorizontal,
                AlignmentVertical: insertVO.AlignmentVertical,
                VesselPlating: insertVO.VesselPlating,
                ColorChange: insertVO.ColorChange,
                Plating: insertVO.Plating,
                Accompaniments: insertVO.Accompaniments,
                QtyCookNecessary: insertVO.QtyCookNecessary,
                QtyCookNecessaryNum: insertVO.QtyCookNecessaryNum,
                QtyCookNecessaryVesselNum: insertVO.QtyCookNecessaryVesselNum,
                VesselShapeCookNecessary: insertVO.VesselShapeCookNecessary,
                VesselCookNecessary: insertVO.VesselCookNecessary,
                PhotoImageCookNecessary: insertVO.PhotoImageCookNecessary,
                CrossSection: insertVO.CrossSection ? '01' : '',
                PhotoRenditionCookNecessary: insertVO.PhotoRenditionCookNecessary,
                QtyCookUnnecessary: insertVO.QtyCookUnnecessary,
                QtyCookUnnecessaryNum: insertVO.QtyCookUnnecessaryNum,
                QtyCookUnnecessaryVesselNum: insertVO.QtyCookUnnecessaryVesselNum,
                VesselShapeCookUnnecessary: insertVO.VesselShapeCookUnnecessary,
                VesselCookUnnecessary: insertVO.VesselCookUnnecessary,
                PhotoImageCookUnnecessary: insertVO.PhotoImageCookUnnecessary,
                PhotoRenditionCookUnnecessary: insertVO.PhotoRenditionCookUnnecessary ? '1' : '',
                CropExistenceType: insertVO.CropExistenceType,
                ReferenceImageFileName1: insertVO.ReferenceImageFileName1,
                PhotoInstructContents1: insertVO.PhotoInstructContents1,
                ReferenceImageFileName2: insertVO.ReferenceImageFileName2,
                PhotoInstructContents2: insertVO.PhotoInstructContents2,
                ReferenceImageFileName3: insertVO.ReferenceImageFileName3,
                PhotoInstructContents3: insertVO.PhotoInstructContents3,
              }
            }
          })
        },
        ImageInfoUpdateList: {
          combination: this.vo.ImageInfoUpdateList.map(updateVO => {
            return {
              condition: {
                ImageID: updateVO.ImageID,
                ImageType: updateVO.ImageType,
                ProcessInstruct: updateVO.ProcessInstruct,
                CookingExPublish: updateVO.CookingExPublish,
                CookingDiv: updateVO.CookingDiv,
                CookingName: updateVO.CookingName,
                MaterialName: updateVO.MaterialName,
                EventID: updateVO.EventID,
                PhotoContentsDiv: updateVO.PhotoContentsDiv,
                Remarks: updateVO.Remarks,
                KeyWord: updateVO.KeyWord,
                PhotoInstructContents: updateVO.PhotoInstructContents,
                TextCaption: updateVO.TextCaption,
                MultipleCode: updateVO.MultipleCode,
                SampleNum: updateVO.SampleNum,
                PromotionFlg: updateVO.PromotionFlg ? '1' : '0',
                Shooting: updateVO.Shooting,
                ShootingPackageText: updateVO.ShootingPackageText,
                ShootingAngle: updateVO.ShootingAngle,
                Alignment: updateVO.Alignment,
                AlignmentHorizontal: updateVO.AlignmentHorizontal,
                AlignmentVertical: updateVO.AlignmentVertical,
                VesselPlating: updateVO.VesselPlating,
                ColorChange: updateVO.ColorChange,
                Plating: updateVO.Plating,
                Accompaniments: updateVO.Accompaniments,
                QtyCookNecessary: updateVO.QtyCookNecessary,
                QtyCookNecessaryNum: updateVO.QtyCookNecessaryNum,
                QtyCookNecessaryVesselNum: updateVO.QtyCookNecessaryVesselNum,
                VesselShapeCookNecessary: updateVO.VesselShapeCookNecessary,
                VesselCookNecessary: updateVO.VesselCookNecessary,
                PhotoImageCookNecessary: updateVO.PhotoImageCookNecessary,
                CrossSection: updateVO.CrossSection ? '01' : '',
                PhotoRenditionCookNecessary: updateVO.PhotoRenditionCookNecessary,
                QtyCookUnnecessary: updateVO.QtyCookUnnecessary,
                QtyCookUnnecessaryNum: updateVO.QtyCookUnnecessaryNum,
                QtyCookUnnecessaryVesselNum: updateVO.QtyCookUnnecessaryVesselNum,
                VesselShapeCookUnnecessary: updateVO.VesselShapeCookUnnecessary,
                VesselCookUnnecessary: updateVO.VesselCookUnnecessary,
                PhotoImageCookUnnecessary: updateVO.PhotoImageCookUnnecessary,
                PhotoRenditionCookUnnecessary: updateVO.PhotoRenditionCookUnnecessary ? '1' : '',
                CropExistenceType: updateVO.CropExistenceType,
                ReferenceImageFileName1: updateVO.ReferenceImageFileName1,
                PhotoInstructContents1: updateVO.PhotoInstructContents1,
                ReferenceImageFileName2: updateVO.ReferenceImageFileName2,
                PhotoInstructContents2: updateVO.PhotoInstructContents2,
                ReferenceImageFileName3: updateVO.ReferenceImageFileName3,
                PhotoInstructContents3: updateVO.PhotoInstructContents3,
              }
            }
          })
        },
        ImageInfoDeleteList: {
          combination: this.vo.ImageInfoDeleteList.map(deleteVO => {
            return {
              condition: {
                ImageID: deleteVO.ImageID
              }
            }
          })
        },
        ReferenceImageDeleteList: {
          combination: this.vo.ReferenceImageDeleteList.map(imageDeleteVO => {
            return {
              condition: {
                ImageID: imageDeleteVO.ImageID,
                ReferenceImageFileName: imageDeleteVO.ReferenceImageFileName,
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof UpdateImageInfoService
   */
  execute(model: any, vo: UpdateImageInfoModel, successFunc: Function): void {
    this.model = <KYMW0C00Model>model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW0C00UpdateImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateImageInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
